module.exports = __webpack_public_path__ + "img/ok.46e931d2.png";